
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créer un site Internet professionnel : Exemples, Prix et Délais",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous voulez faire connaître votre entreprise et développer votre chiffre d’affaires ?",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Créer un site Internet professionnel : Exemples, Prix et Délais",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous voulez faire connaître votre entreprise et développer votre chiffre d’affaires ?",
        },
      ],
    };
  },
};
